import mediaQuery from '../../../helpers/mediaQuery';

function stickyMiniPopupHandler(
  miniPopupElement: HTMLDivElement,
  miniIconElement: HTMLLIElement | null,
  fixToTheTop = true
): {
  miniHandler: () => void;
  miniCleanup: () => void;
} {
  function miniHandler(): void {
    const miniIconHeight = miniIconElement?.offsetHeight || 0;
    const shouldStick = window.pageYOffset >= miniIconHeight && fixToTheTop;
    if (mediaQuery.isXLargeUp() && shouldStick) {
      const { left, width } = miniIconElement?.getBoundingClientRect() || { left: 0, width: 0, right: 0 };
      miniPopupElement.style.position = 'fixed';
      miniPopupElement.style.top = '0px';
      miniPopupElement.style.left = `${
        left +
        width -
        miniPopupElement.getBoundingClientRect().width -
        parseInt(window.getComputedStyle(miniPopupElement).right, 10) // miniCart special treatment
      }px`;
    } else {
      miniCleanup();
    }
  }

  function miniCleanup(): void {
    miniPopupElement.style.removeProperty('position');
    miniPopupElement.style.removeProperty('top');
    miniPopupElement.style.removeProperty('left');
  }

  return { miniHandler, miniCleanup };
}

function animateMiniPopup(
  miniPopupElement: HTMLDivElement | null,
  miniIconElement: HTMLLIElement | null,
  fixToTheTop?: boolean
): void {
  if (miniPopupElement && miniPopupElement.classList.contains('hide')) {
    miniPopupElement.classList.remove('hide');
    const { miniHandler, miniCleanup } = stickyMiniPopupHandler(miniPopupElement, miniIconElement, fixToTheTop);
    window.addEventListener('scroll', miniHandler);
    window.addEventListener('resize', miniHandler);
    miniHandler();
    miniPopupElement.style.animation = 'animation-fade-in 500ms ease-in-out';
    miniPopupElement.addEventListener('animationend', function animationHandler(event: Event) {
      if (event.target !== miniPopupElement) return;
      miniPopupElement.removeEventListener('animationend', animationHandler);
      setTimeout(() => {
        miniPopupElement.style.animation = 'animation-fade-out 500ms ease-in-out';
        miniPopupElement.addEventListener('animationend', function innerAnimationHandler(innerEvent: Event) {
          if (innerEvent.target !== miniPopupElement) return;
          miniPopupElement.removeEventListener('animationend', innerAnimationHandler);
          miniPopupElement.style.removeProperty('animation');
          miniPopupElement.classList.add('hide');
          window.removeEventListener('scroll', miniHandler);
          window.removeEventListener('resize', miniHandler);
          miniCleanup();
        });
      }, 5000);
    });
  }
}

export default animateMiniPopup;
